module.exports = __webpack_public_path__ + "img/vestidos.c99c501e.png";